ThemeJS.Test_Catalogue = ( function ( $, root ) {

    let $filters_form;
    let $line_of_business_tabs;
    let $starts_with_links;

    let $search_input;

    let $advanced_search_toggle;
    let $advanced_search_section;
    let $advanced_filters;
    let $clear_button;

    let $loading_section;
    let $orderby_links;

    let $pagination_wrapper;
    let $pagination_links;

    let $table_body;
    let $dummy_test_row;
    let $no_results_row;

    let new_page_num;
    let active_filters = {
        keyword: null,
        page: null,
        line_of_business: null,
        search: null,
        starts_with: null,
        advanced: {
            active: false,
            filters: {}
        },
        orderby: null
    };

    let debounceFilter;


    function set_global_element_vars () {
        $filters_form = $('#test-catalogue-filters');
        $line_of_business_tabs = $('a.tab-nav-link');
        $search_input = $('#test-catalogue-search');
        $starts_with_links = $('a.starts-with-link');
        $advanced_search_toggle = $('#advanced-search-toggle');
        $advanced_search_section = $('#advanced-search-section');
        $clear_button = $('#clear-filters');
        $loading_section = $('#test-catalogue-loading-section');
        $orderby_links = $('a.orderby-link');
        $pagination_wrapper = $('div.test-catalogue-pagination');
        // advanced filters and pagination set in own methods in case of re-init

        $table_body = $( 'tbody', '#test-catalogue-table' );
        $dummy_test_row = $('tr[data-test_id="dummy"]');
        $no_results_row = $('#no-test-results');
        $dummy_test_row.remove();
        if ( $no_results_row.hasClass('d-none') ) {
            $no_results_row.remove();
            $no_results_row.removeClass('d-none');
        }
    }


    function init_advanced_filters () {
        let $active_orderby = $orderby_links.filter( '.active' );
        if ( $active_orderby.length ) {
            let order = $active_orderby.hasClass( 'desc' ) ? 'DESC': 'ASC';
            active_filters.orderby = {
                field: $active_orderby.data().orderby,
                order
            }
        }

        let $active_starts_with = $starts_with_links.filter( '.active' );
        if ( $active_starts_with.length ) {
            active_filters.starts_with = $active_starts_with.data().starts_with;
        }

        $advanced_filters = $('div.advanced-filter');
        $advanced_filters.each( function () {
            let value = ( $(this).data().filter_type == 'select' ) ? $( 'select', this ).val() : $( 'input', this ).prop( 'checked' );
            active_filters.advanced.filters[ $(this).data().filter_name ] = value ? value : null;
        });
        $('select', $advanced_search_section).select2({
            minimumResultsForSearch: Infinity,
            dropdownCssClass: 'advanced-filters-dropdown'
        });
    }


    function append_pagination ( html ) {
        let $pagination = $( html );
        replace_prev_next_mobile( $pagination );
        $pagination_wrapper.html( $pagination );
    }


    function replace_prev_next_mobile ( $pagination = false ) {
        if ( !$pagination ) {
            $pagination = $pagination_wrapper;
        }
        if ( $( window ).width() < 992 ) {
            $( '.prev', $pagination ).html( '<i class="far fa-chevron-left"></i>' );
            $( '.next', $pagination ).html( '<i class="far fa-chevron-right"></i>' );
            $pagination_links = $( '.page-numbers', $pagination );
            let current_index = $( '.current', $pagination ).index();
            $( '.dots', $pagination ).remove();
            $pagination_links.not('.current, .prev, .next').addClass( 'd-none' );
            let middle_size = ( $( window ).width() > 400 ) ? 1 : 0;
            if ( middle_size ) {
                $pagination_links.eq( current_index - middle_size ).removeClass( 'd-none' );
                $pagination_links.eq( current_index + middle_size ).removeClass( 'd-none' );
            }
            if ( $pagination_links.eq( current_index ).prevUntil( '.prev' ).length > middle_size ) {
                let dots = $('<span />', {
                    class: 'page-numbers dots',
                    text: "..."
                });
                $( dots ).insertAfter( $( '.prev', $pagination ) );
            }
            if ( $pagination_links.eq( current_index ).nextUntil( '.next' ).length > middle_size ) {
                let dots = $('<span />', {
                    class: 'page-numbers dots',
                    text: "..."
                });
                $( dots ).insertBefore( $( '.next', $pagination ) );
            }
        }
    }


    function init_pagination () {
        replace_prev_next_mobile();
        $pagination_links = $('a.page-numbers');
        $pagination_links.each( function () {
            let href = $(this).attr('href');
            let page_num;
            if ( href.includes( '/page/' ) ) {
                let after_page = href.substring( href.indexOf( '/page/' ) + 6 );
                page_num = after_page.substring( 0, after_page.indexOf( '/' ) );
            } else {
                page_num = ThemeJS.Functions.get_query_parameter( 'paged', href );
            }
            $(this).attr( 'data-page_num', page_num );
        });
        $pagination_links.click( function ( e ) {
            e.preventDefault();
            new_page_num = $(this).data().page_num;
            $filters_form.submit();
        });
    }


    function set_active_line_of_business () {
        if ( !$line_of_business_tabs.filter( '.active' ).length ) { return; }
        active_filters.line_of_business = $line_of_business_tabs.filter( '.active' ).data().key;
        $loading_section.attr( 'data-active_tab', active_filters.line_of_business );
        maybe_clear_ils_filters();
    }


    function set_line_counts ( counts ) {
        $.each( counts, ( key, value ) => {
            let $tab = $line_of_business_tabs.filter('[data-key="'+key+'"]');
            if ( $tab.length ) {
                $( 'span.count', $tab ).html( value );
            }
        });
    }


    function repopulate_table ( tests ) {
        $table_body.html('');
        tests.forEach( test => {
            let $clone = $dummy_test_row.clone();
            $clone.attr( 'data-test_id', test.id );
            $( 'a.test-name-link', $clone ).attr( 'href', test.permalink ).html( test.test_name );
            $( 'td.method', $clone ).html( test.method );
            $( 'td.supplier-address', $clone ).html( test.supplier_address );
            $clone.appendTo( $table_body );
        });
        if ( !tests.length ) {
            $no_results_row.appendTo( $table_body );
        } else {
            $no_results_row.remove();
        }
    }


    function maybe_clear_ils_filters () {
        if ( ['all', 'integrative-laboratory-services'].includes( $loading_section.attr( 'data-active_tab' ) ) ) { return; }
        $advanced_filters.filter('[data-filter_name=orderable_by_ontario_nd]').find( 'input[type=checkbox]' ).prop( 'checked', false ).trigger('change');
        $advanced_filters.filter('[data-filter_name=filter_category]').find( 'select' ).val( null ).trigger( 'change' );
    }


    function clear_filters () {
        $search_input.val('');
        clear_starts_with();
        clear_order_by();
        active_filters.search = null;
        $( 'input[type=checkbox]', $advanced_filters ).prop( 'checked', false ).trigger( 'change' );
        $( 'select', $advanced_filters ).val( null ).trigger( 'change' );
    }

    function clear_order_by () {
        $orderby_links.removeClass( 'active asc desc' );
        active_filters.orderby = null;
    }

    function clear_starts_with () {
        $starts_with_links.removeClass( 'active' );
        active_filters.starts_with = null;
    }

    function set_listeners () {

        $(document).on( 'tab-change', function () {
            set_active_line_of_business();
            $filters_form.submit();
        });

        $starts_with_links.click( function ( e ) {
            e.preventDefault();
            let this_item = $(this).data().starts_with;
            active_filters.starts_with = ( active_filters.starts_with == this_item ) ? null : this_item;
            $starts_with_links.each( function () {
                $(this).toggleClass( 'active', $(this).data().starts_with == active_filters.starts_with );
            });
            $filters_form.submit();
        });

        $advanced_search_toggle.click( function ( e ) {
            e.preventDefault();
            active_filters.advanced.active = !active_filters.advanced.active;
            $advanced_search_section.slideToggle( 200 );
        });

        $clear_button.click( function ( e ) {
            e.preventDefault();
            clear_filters();
        });

        $( 'input[type=checkbox]', $advanced_filters ).change( function ( e ) {
            let $filter = $(this).closest( '.advanced-filter' );
            let filter_name = $filter.data().filter_name;
            active_filters.advanced.filters[ filter_name ] = $(this).prop('checked');
            $filters_form.submit();
        });

        $( 'select', $advanced_filters ).change( function ( e ) {
            let $filter = $(this).closest( '.advanced-filter' );
            let filter_name = $filter.data().filter_name;
            active_filters.advanced.filters[ filter_name ] = $(this).val();
            $filter.toggleClass( 'has-selection', Boolean( $(this).val() ) );
            $filters_form.submit();
        });

        $( '.clear-selection', $advanced_filters ).click( function ( e ) {
            let $filter = $(this).closest( '.advanced-filter' );
            $( 'select', $filter ).val(null).trigger('change');
        });

        $orderby_links.click( function ( e ) {
            let field = $(this).data().orderby;
            let previous_orderby = active_filters.orderby;
            let order = ( previous_orderby && previous_orderby.field == field ) ? ( ( previous_orderby.order == 'ASC' ) ? 'DESC' : 'ASC' ) : 'ASC';
            active_filters.orderby = {
                field,
                order
            };
            $orderby_links.removeClass( 'active asc desc' );
            $orderby_links.filter( '[data-orderby="'+active_filters.orderby.field+'"]' ).addClass( 'active '+ active_filters.orderby.order.toLowerCase() );
            $filters_form.submit();
        });

        $filters_form.submit( function ( e ) {
            e.preventDefault();
            clearTimeout( debounceFilter );
            debounceFilter = setTimeout( () => {

                active_filters.keyword = $search_input.val();
                if ( $(':focus').filter( '#test-catalogue-search, #test-catalogue-search-button' ).length ) {
                    clear_order_by();
                    clear_starts_with();
                }

                active_filters.page = new_page_num;
                new_page_num = null;

                $loading_section.loading_screen();

                let filters = get_submission_filters();
                ThemeJS.Cookies.set({
                    test_catalogue_filters: filters
                });
                
                ThemeJS.Functions.send_ajax_request({
                    data: {
                        action: 'test_catalogue_query',
                        filters: filters, 
                    },
                    success ( response ) {
                        set_line_counts( response.line_counts );
                        repopulate_table( response.tests );
                        append_pagination( response.pagination );
                        init_pagination();
                        $loading_section.loading_screen( false );
                    }
                });
            }, 100 );
        });
    }

    
    function get_submission_filters () {
        let filters = {};
        Object.keys( active_filters ).forEach( key => {
            if ( key == 'advanced' ) { return; }
            if ( active_filters[ key ] ) {
                filters[ key ] = active_filters[ key ];
            }
        });
        Object.keys( active_filters.advanced.filters ).forEach( key => {
            if ( active_filters.advanced.filters[ key ] ) {
                filters[ key ] = active_filters.advanced.filters[ key ];
            }
        });
        return filters;
    }


    function init () {
        set_global_element_vars();
        init_advanced_filters();
        init_pagination();
        set_active_line_of_business();
        set_listeners();

        active_filters.keyword = $search_input.val();
        ThemeJS.Cookies.set({
            test_catalogue_filters: get_submission_filters()
        });
    }


    $(function () {
        init();
    });


    return {
        init
    }


})( jQuery, this );